import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import RestaurantHeader from "../components/RestaurantHeader";

const Main = (props) => {
  const { darkMode } = useSelector((state) => state.global);
  const { uid } = useSelector((state) => state.authUser);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);

  const location = useLocation();
  const showBackground =
    location.pathname === `/restaurants` ||
    location.pathname === `/restaurant/${restaurantsDetail?.restaurantID}` ||
    location.pathname === "/info" ||
    location.pathname === "/feedback" ||
    location.pathname === "/table/request/tableNo";

  const showNavbar = location.pathname === "/profile";

  const languagesArray = restaurantsDetail?.languages
    ? restaurantsDetail?.languages
    : ["en"];
  const languagesString = languagesArray.join(",");
  let includedLanguages = languagesString;
  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        includedLanguages: includedLanguages,
        autoDisplay: true,
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    if (restaurantsDetail?.languages) {
      var googleTranslator = document.getElementById(
        "google-translator-script"
      );
      if (!googleTranslator) {
        var addScript = document.createElement("script");

        addScript.setAttribute(
          "src",
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );

        addScript.setAttribute("id", "google-translator-script");
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = googleTranslateElementInit;
      }
    }
  }, [restaurantsDetail?.languages]);

  const className = darkMode ? "main-bg-dark" : "main-bg";

  return (
    <>
      <div className={className}>
        {!showNavbar ? <Header /> : <RestaurantHeader />}
        {!showBackground &&
        location.pathname !== "/profile" &&
        location.pathname !== "/restaurants" &&
        !uid ? (
          <div className="marquee-container py-2">
            <div className="marquee-content text-danger">
              Attention! Please Login or Register to place your order{" "}
              <Link to="/auth">Login</Link>
            </div>
          </div>
        ) : null}
        {props.children}
        <Footer />
      </div>
    </>
  );
};

export default Main;
